import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/RhytSorting/editor/rhytsortingeditor.tsx",
    () => import("./rhytsortingeditor"),
);
